import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DipRegistrationLoggerService} from '../logger/dip-registration-logger.service';
import {DipRegistrationContextService} from '../dip-registration-context.service';


const METHODS = ['GET', 'HEAD', 'TRACE', 'OPTIONS'];

@Injectable()
export class DipRegistrationRequestHeaderInterceptorService implements HttpInterceptor {

  constructor(private logger: DipRegistrationLoggerService, private readonly dipRegistrationContextService: DipRegistrationContextService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.indexOf('/customer-registration/v1') > -1) {
      let headers = new HttpHeaders();
      if (this.dipRegistrationContextService.getEnvironmentId()) {
        headers = headers.append('x-environment-id', this.dipRegistrationContextService.getEnvironmentId());
      }
      headers = headers.append('Content-Type', 'application/json');
      if (METHODS.indexOf(request.method) < 0) {
        const csrfInfo: { csrfHeader: string, csrfToken: string } = this.dipRegistrationContextService.getCsrfInfo();
        if (csrfInfo?.csrfHeader && csrfInfo?.csrfToken) {
          headers = headers.append('x-csrf-header', csrfInfo.csrfHeader);
          headers = headers.append('x-csrf-token', csrfInfo.csrfToken);
          this.logger.debug('CSRF token is added to the request', csrfInfo);
        }
      }
      request = request.clone({headers});
    }
    return next.handle(request);
  }
}
